export default function authHeader() {
  const token = localStorage.getItem("user_free");
  console.log("Raw token from storage:", token);

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
  } else {
    console.log("No token found in storage");
    return {};
  }
}
